import React from "react";
import {
  Box,
  Button,
  Typography,
  styled,
  useTheme,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ErrorBackground } from "./ErrorBackground";
import NotFoundIcon from "./pill.svg?react";
import Background from "./background.svg?react";
import LockIcon from "./lock.svg?react";

const BackgroundImage = styled("div")`
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
  height: 100%;
  overflow: visible;
  z-index: 0;

  & svg {
    width: 1695px;
    color: ${({ theme }) => theme.palette.wizardHeader.spotBg};
    margin-top: -60%;
    margin-left: 60%;
    opacity: 0.75;
  }
`;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  padding: theme.spacing(2),
  zIndex: 1,
}));

const Card = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 4,
  padding: theme.spacing(8),
  maxWidth: 720,
  position: "relative",
  zIndex: 2,
}));

export const NotFoundPage = ({ onGoHome }: { onGoHome?: () => void }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const goHome = () => {
    if (onGoHome) return onGoHome();
    window.location.href = `${import.meta.env.VITE_APP_ROOT_URL || ""}/app`;
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: theme.bankConnection?.background,
      }}
    >
      <Container>
        <BackgroundImage>
          <Background />
        </BackgroundImage>

        <Card
          sx={{
            overflow: "hidden",
            width: "100%",
          }}
        >
          <ErrorBackground />
          <Box
            position="relative"
            sx={{ zIndex: 2 }}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Card
              sx={{
                width: 162,
                marginBottom: theme.spacing(14),
                borderRadius: 3,
              }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <LockIcon color={theme.palette.primary.main} />
                <Box
                  position="absolute"
                  bottom={-29}
                  left="50%"
                  sx={{
                    transform: "translateX(-50%)",
                    "--svg-primary-color":
                      theme.palette.graphVisual["07"].light,
                    "--svg-secondary-color":
                      theme.palette.graphVisual["02"].mid,
                    "--svg-tertiary-color": theme.palette.secondary.dark,
                  }}
                >
                  <NotFoundIcon />
                </Box>
              </Box>
            </Card>
            <Typography variant="h4" mb={2.5}>
              {t("notFound.title")}
            </Typography>
            <Typography color="text.secondary" mb={11}>
              {t("notFound.text")}
            </Typography>

            {onGoHome && (
              <Button variant="primary" onClick={goHome} fullWidth>
                {t("notFound.button")}
              </Button>
            )}
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
